module.exports = __webpack_public_path__ + "static/media/tartaruga-de-pente.61af38f3.png";